'use client';

import { createContext, useContext, type ReactNode } from 'react';

import type { OpticalProcedureCopywriting } from './types';

const OpticalProcedureCopywritingContext = createContext<OpticalProcedureCopywriting>({});

export function OpticalProcedureCopywritingProvider({
  value,
  children,
}: {
  value?: OpticalProcedureCopywriting | null;
  children: ReactNode;
}) {
  return (
    <OpticalProcedureCopywritingContext.Provider value={value || {}}>
      {children}
    </OpticalProcedureCopywritingContext.Provider>
  );
}

export function useOpticalProcedureCopywriting() {
  return useContext(OpticalProcedureCopywritingContext);
}
